import { render } from "./icon-arrow-narrow.svg?vue&type=template&id=5190f950?inline"
const script = {}
script.render = render

export default script